import { NotificationPwaModule } from './shared/modules/notification-pwa/notification-pwa.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { RouterModule } from '@angular/router';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireFunctionsModule, REGION } from '@angular/fire/compat/functions';
import { environment } from '../environments/environment';
import { routes } from './app.routing';
import { NgLoggerModule } from '@nsalaun/ng-logger';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import * as Sentry from "@sentry/angular";
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';

// Import locale required for DatePipe
import { registerLocaleData } from '@angular/common';
import localePL from '@angular/common/locales/pl';
import localeJA from '@angular/common/locales/ja';
import localeUK from '@angular/common/locales/uk';
registerLocaleData(localePL, 'pl');
registerLocaleData(localeJA, 'ja');
registerLocaleData(localeUK, 'uk');

import { FirebaseAppCheckService } from './firebase-app-check.service';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'corrected' }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    NgLoggerModule.forRoot(environment.loggingLevel),
    HttpClientModule,
    TranslateModule.forRoot(),
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.enableServiceWorker }),
    ServiceWorkerModule.register('ngsw-worker.js'),
    NotificationPwaModule
  ],
  providers: [
    // Set Firebase functions location
    {
      provide: REGION,
      useValue: environment.region
    },
    // Service worker 
    {
      provide: SwRegistrationOptions,
      // useFactory: () => ({ enabled: environment.enableServiceWorker }),
      useFactory: () => ({
        enabled: environment.enableServiceWorker,
        registrationStrategy: "registerImmediately"
      })
    },
    // Agnular service to manipulate page titles
    Title,
    // Sentry.io js errors tracking
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private appCheck: FirebaseAppCheckService) { } // Injection forces app check instantiation
}
